module.exports = __webpack_public_path__ + "img/show1.98fcdd43.png";